import * as Yup from 'yup'

export const SignInSchema = Yup.object({
  correo: Yup.string()
    .email('Correo electrónico invalido')
    .required('Requerido'),
  password: Yup.string().required('Requerido')
})
